export const stepperConfig = [
  { 1: 'Select Locations' },
  { 2: 'Agree to Terms' },
  { 3: 'Review Subscription' }
];
